import { TopToolbar, ListButton } from 'react-admin';

/**
 * Custom actions for variant SKU edit view
 * Includes back to catalog list button
 */
export const VariantSkuEditActions = () => (
  <TopToolbar>
    <ListButton resource="catalog-items" label="Back to Catalog" />
  </TopToolbar>
);
